:host {
    display: block;
}
::slotted(.card-text) {
    font-size: small !important;
}